import Store from '@/store'
import * as mutationTypes from '@/store/mutationTypes';

import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Device as DeviceDetect } from '@capacitor/device';

import ApiService from '@/services/ApiService';

const Device = {

    /*
     * Detect the device
     */
    async detect() {
        let device = await DeviceDetect.getInfo()
        device.platform = window.electron ? 'electron' : device.platform;

        if(device.platform === 'android' || device.platform === 'ios') {
            const deviceId = await DeviceDetect.getId()
            device.uuid = deviceId.uuid || deviceId.identifier
        }

        if(device.platform === 'web') {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            device.uuid = result.visitorId
        }

        if(device.platform === 'electron') {
            device.uuid = await window.electron.invoke('el-uuid')
        }

        return device
    },

    /*
     * Get the device from store
     */
    get() {
        return Store.getters.device
    },

    /*
     * Set the device in store
     */
    set(device) {
        if(window.electron && !device.electron) {
            const curDevice = this.get()
            if(curDevice) {
                device = { ...device, electron: curDevice.electron }
            }
        }

        Store.commit(mutationTypes.SET_DEVICE, { device: device })
        ApiService.setDeviceUuidHeader();
        ApiService.setDevicePlatformHeader();
    },

    isWeb() {
        const device = this.get();
        return device?.platform === 'web';
    },

    isAndroid() {
        const device = this.get();
        return device?.platform === 'android'
    },

    isIOS() {
        const device = this.get();
        return device?.platform === 'ios'
    },

    isMobile() {
        const device = this.get();
        return device?.platform === 'android' || device?.platform === 'ios';
    },

    isElectron() {
        const device = this.get();
        return device?.platform === 'electron';
    },
};

export default Device;

export { Device };
